import { useTranslator } from './I18nContext'

/**
 * Resolve a text prop that may come either as a plain string (legacy)
 * or as a translation key (`tid`). Returns a string ready to render.
 *
 * Usage in a component:
 *   const resolve = useResolveText()
 *   const labelText = resolve(labelTid, label)
 */
export function useResolveText() {
  const t = useTranslator()
  return (tid: string | undefined, fallback: string | undefined, values?: Record<string, unknown>): string | undefined => {
    if (tid) return t(tid, values)
    return fallback
  }
}
